import React, { useCallback } from 'react';

import { IconButton } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';

const AuditExpandToggle = ({ rowId, isExpanded, onToggle }) => {
  const onClick = useCallback(() => onToggle(rowId), [onToggle, rowId]);

  return (
    <IconButton
      aria-expanded={isExpanded}
      aria-label={isExpanded ? 'Collapse' : 'Expand'}
      data-testid={`${EntityAuditHistoryTestIds.ROW_TRIGGER}-${rowId}`}
      size="small"
      onClick={onClick}
    >
      <ArrowCheckIcon
        direction={isExpanded ? IconDirection.DOWN : IconDirection.RIGHT}
        size={IconSize[16]}
      />
    </IconButton>
  );
};

AuditExpandToggle.propTypes = {
  rowId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default AuditExpandToggle;
